import { resolveUserAppTheme } from '@disenchantment/shared';
import type { AppThemeCustomization } from '@disenchantment/types';
import { applyAppThemeCssVars } from './applyAppTheme';

export function applyUserAppTheme(
  themeId: string,
  customization?: AppThemeCustomization | null
): void {
  applyAppThemeCssVars(resolveUserAppTheme(themeId, customization));
}
